export function onDOMContentLoaded(callback) {
    if (!callback) {
        return;
    }

    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        callback();
    } else {
        window.addEventListener('DOMContentLoaded', () => {
            callback();
        });
    }
}
